import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';
import { TPaymentStatus } from '../../types/reducers/depositAccount';

export const UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS = 'DEPOSIT_ACCOUNT :: UPDATE_PAYMENT_STATUS';

export type TUpdateDepositAccountPaymentStatusAction = IReduxAction<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  TPaymentStatus
>;

export const updateDepositAccountPaymentStatus = actionGenerator<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS,
  TPaymentStatus
>(UPDATE_DEPOSIT_ACCOUNT_PAYMENT_STATUS);
